import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  TextField,
  Button,
  Select,
  MenuItem,
  Typography,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Pagination,
  Grid,
  Card,
  Divider,
  Avatar,
  LinearProgress,
  Tooltip,
} from "@mui/material";
import { Edit, Delete, Search } from "@mui/icons-material";

import ApiEndpoints from "../../network/ApiEndPoints";
import { apiErrorToast } from "../../utils/ToastUtil";
import { get, postJsonData } from "../../network/ApiController";

import RefreshComponent from "../../component/RefreshComponent";
import ApiPaginateSearch from "../../component/ApiPaginateSearch";
import { dateToTime, ddmmyy, ddmmyyyy } from "../../utils/DateUtils";
import AuthContext from "../../store/AuthContext";
import { CustomStyles } from "../../component/CustomStyle";
import CachedIcon from "@mui/icons-material/Cached";
import CreateUtils from "./CreateUtils";
import UpdateUtil from "./UpdateUtil";
import DeleteUtil from "./DeleteUtil";
let refresh;
const AdminUtility = () => {
  const [apiData, setApiData] = useState([]);
  const [query, setQuery] = useState("");
  const authCtx = useContext(AuthContext);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("All");
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [task, setTask] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [refresh, setRefresh] = useState(null);
  function refreshFunc(setQuery) {
    setQuery("");
    if (refresh) refresh();
  }
  const user = authCtx?.user;
  const handleSearch = (event) => {
    setSearch(event.target.value);
  };
  const getUtil = async (e) => {
    setLoading(true);
    get(
      ApiEndpoints.GET_UTILS,
      setLoading,
      (res) => {
        console.log("Success:", res.data);
        refresh();
        setLoading(false);
      },
      (error) => {
        setLoading(false);
      }
    );
  };

  const columns = [
    {
      name: "Id",
      selector: (row) => <div>{row.id}</div>,

      omit: user && user.role === "Admin" ? false : true,
    },
    {
      name: "Type",
      selector: (row) => <div>{row.type}</div>,
    },
    {
      name: "Name",
      selector: (row) => <div>{row.name}</div>,
    },
    {
      name: "Created At",
      selector: (row) => (
        <Tooltip title={ddmmyyyy(row.created_at)}>
          <span>{ddmmyy(row.created_at)}</span>
        </Tooltip>
      ),
    },
    {
      name: "Updated At",
      selector: (row) => (
        <Tooltip title={ddmmyyyy(row.updated_at)}>
          <span>{ddmmyy(row.updated_at)}</span>
        </Tooltip>
      ),
    },
    {
      name: "Actions",
      selector: (row) => (
        <div
          style={{
            display: "flex",

            width: "100px",
          }}
        >
          <UpdateUtil row={row} getUtil={getUtil} />
          <DeleteUtil row={row} getUtil={getUtil} />
        </div>
      ),
    },
  ];

  return (
    <>
      <Grid sx={{ mt: 4}}>
        <Box sx={{ display: "flex", justifyContent: "flex-end",  }}>
     
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Tooltip title="refresh">
              <IconButton
                aria-label="refresh"
                sx={{
                  color: "#0F52BA",
                }}
                onClick={() => {
                  refreshFunc(setQuery);
                }}
              >
                <CachedIcon className="refresh-purple" />
              </IconButton>
            </Tooltip>
            <CreateUtils refresh={refresh} />
          </Box>
        </Box>
        <ApiPaginateSearch
          apiEnd={ApiEndpoints.GET_UTILS}
          columns={columns}
          apiData={apiData}
          setApiData={setApiData}
          tableStyle={CustomStyles}
          queryParam={query ? query : ""}
          returnRefetch={(ref) => setRefresh(() => ref)}
        />
      </Grid>
    </>
  );
};

export default AdminUtility;
